/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Carrier_Delivered_DescInputs */

const vi_order_carrier_delivered_desc = /** @type {(inputs: Order_Carrier_Delivered_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ghi lại thông tin đối chiếu (mã vận đơn, thời điểm giao thực tế, …). Bắt buộc nhập tối thiểu 3 ký tự để lưu vết.`)
};

/**

* @param {Order_Carrier_Delivered_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_carrier_delivered_desc = /** @type {((inputs?: Order_Carrier_Delivered_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Carrier_Delivered_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_carrier_delivered_desc(inputs)
});